type StarRatingProps = {
  count?: number
  className?: string
}

export default function StarRating({ count = 5, className = '' }: StarRatingProps) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 14 14" fill="#FF7027">
          <path d="M7 0.5L8.85 5.13L14 5.44L10.15 8.62L11.4 13.5L7 10.88L2.6 13.5L3.85 8.62L0 5.44L5.15 5.13L7 0.5Z" />
        </svg>
      ))}
    </div>
  )
}
